import { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import {
  SubmitConsumptionEntryMutation,
  SubmitConsumptionEntryMutationVariables,
  SubmitUserProfileMutationVariables,
  SubmitProductEntryMutationVariables,
  SubmitProductEntryMutation,
  SubmitUserProfileMutation,
  useGetProfileQuery,
  useSubmitConsumptionEntryMutation,
  useSubmitProductEntryMutation,
  useSubmitUserProfileMutation,
  useProductEntriesQuery
} from "../../generated/graphql";
import { Typography, Space, Card, Spin, Button, Divider, Descriptions } from "antd";
import { authContext } from "../../components/auth/AuthContext";
import { ProductList } from "../../components/product-list/ProductList";
import { UserProfileUpdateModal } from "../../components/user-profile-update/UserProfileUpdate";
import { EntrySubmissionModal } from "../../components/entry-submission/EntrySubmissionModal";
import { ProductSubmissionModal } from "../../components/product-submission/ProductSubmissionModal";
import { MutationResult } from "@apollo/client";
import { Redirect } from "react-router-dom";
const { Title, Text } = Typography;
interface Props {}

export const UserProfile = (props: Props) => {
  const context = useContext(authContext);
  if (context?.isUserSignedIn) {
  }
  const [submitEntry, { loading: entryModalLoading }] = useSubmitConsumptionEntryMutation();
  const [submitProductEntry, { loading: productModalLoading }] = useSubmitProductEntryMutation();
  const [submitUserProfileUpdate, { loading: userProfileModalLoading }] = useSubmitUserProfileMutation();

  // Subbmission Handlers for Modals | unique for TS vars
  const successEntrySubmissionHandler = (
    data: MutationResult<SubmitConsumptionEntryMutation>["data"]
  ) => {
    setEntryModalVisible(false);
    setProductEntryModalVisible(false);
    setUserProfileModalVisible(false);
    window.location = window.location;
  };

  const successProductEntrySubmissionHandler = (
    data: MutationResult<SubmitProductEntryMutation>["data"]
  ) => {
    setEntryModalVisible(false);
    setProductEntryModalVisible(false);
    setUserProfileModalVisible(false);
    // TODO AFTER BETA: push new returned object to the user 
    //product?.data?.product_entries.push(data?.insert_product_entries?.returning[0])
    window.location = window.location;
  };

  const successUserProfileModalSubmissionHandler = (
    data: MutationResult<SubmitUserProfileMutation>["data"]
  ) => {
    setEntryModalVisible(false);
    setProductEntryModalVisible(false);
    setUserProfileModalVisible(false);
    window.location = window.location;
  };

 // Submit Handlers
  const submitUserProfileHandler = (values: SubmitUserProfileMutationVariables) => {
   
    const newValues = values;
    newValues.user_id = id;
    
    submitUserProfileUpdate({ variables: newValues })
      .then(({ errors, data }) => {
        return errors
          ? console.error(errors)
          : successUserProfileModalSubmissionHandler(data);
      })
      .catch(console.error);
  };

  const submitEntryHandler = (values: SubmitConsumptionEntryMutationVariables) => {
   
    const newValues = values;
    newValues.user_id = id;
    
    submitEntry({ variables: newValues })
      .then(({ errors, data }) => {
        return errors
          ? <Redirect to="/signin" />
          : successEntrySubmissionHandler(data);
      })
      .catch(console.error);
  };

  const submitProductEntryHandler = (values: SubmitProductEntryMutationVariables) => {
    // const strainData = values?.variety_name?.toString()?.split("_") || [];
    // const consumptionData = values?.variety_name?.toString()?.split("_") || [];
    const newValues = values;
    // newValues.cbn
    // newValues.cbc = values.cbc + document?.getElementById(id)?.value
    // newValues.cbg
    // newValues.cbd
    // newValues.cbda
    // newValues.thc
    // newValues.thcv
    // newValues.thca
    // newValues.variety_name = strainData[0];
    // newValues.strain_id = strainData[1];
    // newValues.strain_id = consumptionData[1];
    newValues.user_id = id;
    newValues.user_description = newValues.user_description?.toString();
    
    submitProductEntry({ variables: newValues })
      .then(({ errors, data }) => {
        return errors
          ? <Redirect to="/signin" />
          : successProductEntrySubmissionHandler(data);
      })
      .catch(console.error);
  };
 
  /* Modal Controls */
  const [entryModalVisible, setEntryModalVisible] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [productEntryModalVisible, setProductEntryModalVisible] = useState(false);
  const [userProfileModalVisible, setUserProfileModalVisible] = useState(false);

  const { id } = useParams<{ id: string }>();
  const profile = useGetProfileQuery({ variables: { id } });
  const product = useProductEntriesQuery({
    variables: { userId: id.toString() } as any,
  }) ;
  const userData = profile?.data?.user_profiles[0];

  if (profile?.error) {
    return  profile?.error?.message.indexOf('JWT') !== -1 ? <Redirect to="/signin" /> : <Text>{profile?.error.message}</Text>;
  }
  return profile?.loading || userProfileModalLoading || entryModalLoading || productModalLoading ? (
    <Space  style={{width:"100%", margin: '0 auto', maxWidth: '1000px'}} size={2} direction="vertical" align="center">
      <Spin />
    </Space>
  ) : (
    <>
      <div className="site-card-border-less-wrapper"  style={{width:"100%", margin: '0 auto', maxWidth: '1000px'}}>
        <div style={{display:"flex", flexDirection: "column"}}>
          <Card title="User Profile" bordered={true} style={{ width: '100%',  maxWidth: '800px', minWidth:'300px' }}>
          <Descriptions
                bordered
                column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                style={{ width: "100%", whiteSpace:"nowrap" }}
              >
            <Descriptions.Item label="Name">
              <span style={{ fontSize: "12pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{userData?.display_name}</span> 
            </Descriptions.Item>
            <Descriptions.Item label="Location">
              <span style={{ fontSize: "12pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{userData?.state}</span> 
            </Descriptions.Item>
            <Descriptions.Item label="Date of bitrh">
              <span style={{ fontSize: "10pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{userData?.dob ? moment(userData?.dob).format('DD/MM/YYYY') : ''}</span> 
            </Descriptions.Item>
          </Descriptions>
          <br/>
          {!userData?.dob ? (<Button
              type="primary"
              onClick={() => {
                setUserProfileModalVisible(true);
              }}
            >
              Update Profile to Start
            </Button>):
            ''}
        </Card>
        <br/>
        <br/>
        {userData?.dob ? (
          <Card title="Start Here!" bordered={true} style={{ width: '100%',  maxWidth: '800px', minWidth:'300px' }}>
            <Space size={6} direction="vertical" align="center">
              <Text>Log your cannabis products by hitting new product below</Text>
              <br/>
              <Button
                type="primary"
                style={{backgroundColor: !userData?.dob ? 'grey' : 'rgb(114, 114, 233)'}}
                onClick={() => {
                  setProductEntryModalVisible(true);
                }}
                disabled={!userData?.dob}
              >
                Add Product
              </Button>
            </Space>
          </Card>
        ) : ''
        }
      </div>
      <br /><Button type="primary" onClick={()=> {context?.signout()}}>Sign Out</Button>
      <br />
      <br />
        <ProductSubmissionModal
          visible={productEntryModalVisible}
          id={id}
          onCreate={submitProductEntryHandler}
          onCancel={() => {
            setProductEntryModalVisible(false);
          }}
        />

        <EntrySubmissionModal
          visible={entryModalVisible}
          id={id}
          product={selectedProduct}
          onCreate={submitEntryHandler}
          onCancel={() => {
            setEntryModalVisible(false);
          }}
        />

        <UserProfileUpdateModal
          visible={userProfileModalVisible}
          id={id}
          product={selectedProduct}
          onCreate={submitUserProfileHandler}
          onCancel={() => {
            setUserProfileModalVisible(false);
          }}
        />

        <Divider></Divider>
        <Title level={5}>Your Cannabis Products</Title>
        <ProductList productData={product.data} productDataLoading={product.loading}  setEntryModalVisible={setEntryModalVisible} setSelectedProduct={setSelectedProduct} />
      </div>
    </>
  );
};
